import { render } from "./AddressAutocompleteKleber.vue?vue&type=template&id=5ece9647&scoped=true"
import script from "./AddressAutocompleteKleber.vue?vue&type=script&lang=js"
export * from "./AddressAutocompleteKleber.vue?vue&type=script&lang=js"

import "./AddressAutocompleteKleber.vue?vue&type=style&index=0&id=5ece9647&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ece9647"]])

export default __exports__